import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/app.config';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { AuthService } from 'src/app/services/auth.service';
import { SidebarComponent } from 'src/app/shared/components/sidebar/sidebar.component';
import { AppNavItemComponent } from 'src/app/shared/components/sidebar/nav-item/nav-item.component';
import { TranslateService } from '@ngx-translate/core';
import { INavItem } from 'src/app/interfaces/ICommon';
import { HeaderComponent } from './vertical/header/header.component';
import { NAV_ITEM_ADMIN_SIDEBAR, NAV_ITEM_SIDEBAR } from 'src/app/shared/constants';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOW_MONITOR = 'screen and (max-width: 1023px)';
const DESKTOP_VIEW = 'screen and (max-width: 1200px)';

@Component({
    selector: 'app-full',
    imports: [RouterModule, AppNavItemComponent, MaterialModule, CommonModule, SidebarComponent, NgScrollbarModule, TablerIconsModule, HeaderComponent],
    templateUrl: './full.component.html',
    styleUrls: ['./full.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FullComponent implements OnDestroy {
  @ViewChild('leftsidenav') public sidenav: MatSidenav;
  resView = false;
  @ViewChild('content', { static: true }) content!: MatSidenavContent;
  //get options from service
  options = this.settings.getOptions();
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private htmlElement!: HTMLHtmlElement;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  navItems: INavItem[] = this.authService.loggerUser?.userRoles[0]?.role === 1 ? NAV_ITEM_ADMIN_SIDEBAR : NAV_ITEM_SIDEBAR;

  footer: string = this.translateService.instant('copy right', { year: (new Date()).getFullYear() });

  constructor(
    public authService: AuthService,
    private settings: CoreService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private translateService: TranslateService) {
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver.observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOW_MONITOR, DESKTOP_VIEW]).subscribe((state) => {
      // SidenavOpened must be reset true when layout changes
      this.options.sidenavOpened = true;
      this.isMobileScreen = state.breakpoints[DESKTOP_VIEW];
      if (this.options.sidenavCollapsed == false) {
        this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
      }
      this.resView = state.breakpoints[DESKTOP_VIEW];
    });

    // Initialize project theme with options
    this.receiveOptions(this.options);

    // This is for scroll to top
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.content.scrollTo({ top: 0 });
    });
    this.translateService.onLangChange.subscribe(() => {
      this.footer = this.translateService.instant('copy right', { year: (new Date()).getFullYear() });
    });
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
    this.htmlElement.classList.remove('dark-theme');
    this.htmlElement.classList.add('light-theme');
  }

  toggleCollapsed() {
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.htmlElement.classList.remove('dark-theme');
    this.htmlElement.classList.add('light-theme');
  }
}
